export default __webpack_public_path__ + "static/media/bestVerbatim.ffa76ff8.png";